export enum AppointmentType {
    FOLLOWUP = 1,
    NEW_CASE = 2
}
export const AppointmentTypeLabels: Record<AppointmentType, string> = {
    [AppointmentType.FOLLOWUP]: "Followup",
    [AppointmentType.NEW_CASE]: "New Case"
};
